<template>
  <div class="user">
    <h3 class="title">
      {{ $t('topnav.settings') }}
    </h3>
    <div>
      <div class="loading" v-if="loading">
        {{ $t('loading')}}...
      </div>
      <div v-else-if="error">
          <Error :message="error"/>          
      </div>
      
      <div class="form" v-else>
        <div class="form-group">
          <label for="">{{ $t('login.name') }}</label>
          <input type="text" class="form-control" v-model='user.name'>
        </div>
        <div class="form-group">
          <label for="">{{ $t('login.email') }}</label>
          <input type='text' name="email" class="form-control" :value='user.email' disabled="true">
        </div>
        <div class="form-group">
          <label for="">{{ $t('login.password') }}</label>
          <input type="password" class="form-control" v-model='password.password' name="password">
        </div>
        <div class="form-group">
          <label for="">{{ $t('login.password_repeat') }}</label>
          <input type="password" class="form-control" v-model='password.password_confirmation' name="password_confirmation">
        </div>
        <div class="form-group">
          <label for="">{{ $t('login.registered_on') }}</label>
          <p class="form-control-static" v-if="user.user_since">{{ new Date(user.user_since).toLocaleDateString(lang, {timeZone: 'Europe/Vienna'}) }}</p>
        </div>
        <div class="form-group">
          <label>{{ $t('login.teams') }}</label>
          <p class="form-control-static">
            <span class="label label-danger teams" :key="index" v-for='(team, index) in user.teams'>{{team}}</span>
          </p>
        </div>
        <div class="form-group">
          <label>{{ $t('language') }}</label>
          <Flags/>
        </div>
        <div class="form-group" style="text-transform:capitalize">
          <router-link :to="{name:'Terms'}" target="_blank">
            {{ $t('login.terms')}}
          </router-link>
        </div>

        <button class="btn submit" @click="update">{{ $t('login.update') }}</button>
        <button class="btn submit red" @click="$router.push({name:'UserDelete'})">{{ $t('login.delete') }}</button>
      </div>
    </div>
  </div>
</template>


<script>
import Flags from './common/Flags'
import Error from './common/Error.vue'

import api from '../api'

import {
  mapState
} from 'vuex'

export default {
  name: 'User',
  components: {
    Flags, Error
  },
  data () {
    return {
      loading: false,
      error: false,
      user: {
        name: '',
        email: null,
        teams: [],
        user_since: null
      },
      password: {
        password: '',
        password_confirmation: ''
      }
    }
  },
  created () {
    this.loading = true
    this.$Progress.start()
    this.$Progress.set(25)

    api.getUser()
      .then((r) => {
        this.user = r.data
        this.loading = false
        this.$Progress.finish()
      })
      .catch(
        (e) => {
          this.loading = false
          this.$Progress.fail()
          this.error = e.response.data.error
        }
      )
  },
  methods: {
    update () {
      var self = this
      var payload = {
        name: self.user.name
      }
      if (self.password.password.length) {
        payload.password = this.password.password
        payload.password_confirmation = this.password.password_confirmation
      }
      this.$Progress.start()
      this.$Progress.set(25)
      api.postUser(payload)
        .then(() => self.$Progress.finish())
        .catch(() => self.$Progress.fail())
    }
  },
  computed: {
    ...mapState(['env', 'lang'])
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="stylus" src="../styles/_User.styl"/>



// WEBPACK FOOTER //
// src/components/User.vue